import {
  faAddressCard,
  faArrowUpRightFromSquare,
  faBars,
  faBicycle,
  faBook,
  faBookReader,
  faBriefcase,
  faBullhorn,
  faCalendarDay,
  faCamera,
  faChalkboardTeacher,
  faChartLine,
  faChartBar,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faComments,
  faCopy,
  faEnvelope,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faFileAlt,
  faFileExport,
  faFlag,
  faCog,
  faGraduationCap,
  faHandshake,
  faHome,
  faInfoCircle,
  faLock,
  faPhone,
  faPlus,
  faPollH,
  faQuoteRight,
  faSearch,
  faSpinner,
  faTimes,
  faTrash,
  faUniversity,
  faUsers,
  faUserFriends,
  faVenusMars,
  faVial,
  faVideo,
  faEllipsisV,
  faUsersCog,
  faHistory,
  faDownload,
  faSmile,
  faMeh,
  faFrown,
  faBan,
  faEdit,
  faMobileAlt,
  faPencilAlt,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(
  faAddressCard,
  faArrowUpRightFromSquare,
  faBars,
  faBan,
  faBicycle,
  faBook,
  faBookReader,
  faBriefcase,
  faBullhorn,
  faCalendarDay,
  faCamera,
  faChalkboardTeacher,
  faChartLine,
  faChartBar,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faComments,
  faCopy,
  faDownload,
  faEllipsisV,
  faEdit,
  faEnvelope,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faFileAlt,
  faFileExport,
  faFlag,
  faFrown,
  faCog,
  faGraduationCap,
  faHandshake,
  faHistory,
  faHome,
  faInfoCircle,
  faLock,
  faMeh,
  faMobileAlt,
  faPhone,
  faPlus,
  faPollH,
  faQuoteRight,
  faSearch,
  faSmile,
  faSpinner,
  faTimes,
  faTrash,
  faUniversity,
  faUsers,
  faUsersCog,
  faUserFriends,
  faVenusMars,
  faVial,
  faVideo,
  faPencilAlt,
  faUser
);
